/**
 * O que a fila de correção do upload manda para os Ajustes ao clicar em
 * "Criar no cadastro" (2026-10-08): `?tab=temas&novo=Economia Verde&marca=4`
 * abre a aba de temas com o formulário de novo tema já com nome e marca.
 *
 * Só vale o que a aba SABE preencher — `fonte` só na mensagem-chave, e
 * valor inválido some em vez de preencher errado. Puro e testado; a página
 * só aplica, uma vez.
 */

export type SettingsPrefill = {
  name: string;
  brandId: number | null;
  /** Fonte da mensagem-chave; ignorada nas outras abas. */
  source: "press" | "network" | null;
};

export function readSettingsPrefill(params: URLSearchParams): SettingsPrefill | null {
  const name = params.get("novo")?.trim();
  if (!name) return null;
  const rawBrand = Number(params.get("marca"));
  const source = params.get("fonte");
  return {
    name,
    brandId: Number.isInteger(rawBrand) && rawBrand > 0 ? rawBrand : null,
    source: source === "press" || source === "network" ? source : null
  };
}
